
      console.log('VITE_API_URL from index.html:', import.meta.env.VITE_API_URL);
      console.log('VITE_SENTRY_DSN_PUBLIC from index.html:', import.meta.env.VITE_SENTRY_DSN_PUBLIC);
      console.log('MODE from index.html:', import.meta.env.MODE);
    